import { Link } from 'react-router-dom';

export default function QuoteCards() {
  return (
    <section className="relative z-10 -mt-16 px-4 pb-0">
      <div className="max-w-screen-xl mx-auto flex flex-col lg:flex-row gap-0 shadow-lg">
        {/* Left: 3 category cards */}
        <div className="bg-white flex-1 grid grid-cols-1 sm:grid-cols-3">
          {[
            {
              icon: 'ri-home-4-line',
              title: 'Personal',
              desc: 'Protect what you love most.',
              href: '/insurance-solutions#personal',
            },
            {
              icon: 'ri-briefcase-4-line',
              title: 'Business',
              desc: 'Safeguard your business.',
              href: '/insurance-solutions#business',
            },
            {
              icon: 'ri-building-2-line',
              title: 'Industries',
              desc: 'Cover the unique needs of your business.',
              href: '/insurance-solutions#industry',
            },
          ].map((card) => (
            <Link
              key={card.title}
              to={card.href}
              className="group flex flex-col items-center justify-center text-center px-6 py-10 border border-[#9cbde5]/40 hover:bg-[#9cbde5]/20 transition-colors cursor-pointer"
            >
              <div className="w-14 h-14 flex items-center justify-center mb-4">
                <i className={`${card.icon} text-4xl text-[#9cbde5]`} />
              </div>
              <p className="text-[#0b2240] font-bold text-base mb-1">{card.title}</p>
              <p className="text-gray-500 text-sm">{card.desc}</p>
            </Link>
          ))}
        </div>

        {/* Right: Get Quote dark panel */}
        <div className="bg-[#0b2240] w-full lg:w-80 flex flex-col items-center justify-center px-8 py-10 text-white text-center">
          <h3 className="text-xl font-bold mb-5">Get Started with a Quote</h3>
          <div className="w-full h-px bg-white/20 mb-6" />
          <div className="grid grid-cols-2 gap-3 w-full">
            <Link
              to="/contact"
              className="flex flex-col items-center gap-2 bg-white/5 hover:bg-[#c03221] border border-white/20 rounded-md px-4 py-5 transition-colors"
            >
              <i className="ri-user-3-line text-2xl text-[#9cbde5]" />
              <span className="text-xs font-semibold text-white">Personal Lines Quote</span>
            </Link>
            <Link
              to="/contact"
              className="flex flex-col items-center gap-2 bg-white/5 hover:bg-[#c03221] border border-white/20 rounded-md px-4 py-5 transition-colors"
            >
              <i className="ri-store-2-line text-2xl text-[#9cbde5]" />
              <span className="text-xs font-semibold text-white">Business Lines Quote</span>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
